module.exports = __webpack_public_path__ + "35fe17e9e7bb994a37545a24881dd231.MP3";